import isString from 'lodash/isString';

const parseValue = (value: any) => {
  return !isString(value)
    ? JSON.stringify(value)
        .replace(/&amp;/g, '&')
        .replace(/&quot;/g, '"')
    : value;
};

export default parseValue;
